import { gql } from '@apollo/client';
import {
  CREDIT_DECISION_PARSED_DATA_FRAGMENT,
  CREDIT_SUBMISSION_DECISION_FRAGMENT,
} from 'modules/creditSubmission/api';

export const GET_CREDIT_SUBMISSION = gql`
  query CreditSubmissionById($csId: ID!) {
    creditSubmission(dynamicsId: $csId) {
      creditSubmissionId
      lenderProfileId
      dynamicsLenderProfileId
      createdDateTime
      applicant
      amountRequested
      businessName
      creditSubId
      stage
      submissionDate
      decision
      dealer
      contactUserProfileId
      contact
      transactionId
      contactName
      contactPhone
      pgTransactionId
      voId
      dynamicsVOId
      pgTransactionId
      dealerVendorProfile
      contactEmail
      invoiceTotal
      equipmentDescription
      equipmentApprovalStatus
      equipmentCondition
      equipmentCost
      freightLaborInstallation
      downPayment
      salesTaxOnInvoice
      dealerId
      lenderAccountId
      transactionSummary
      transactionSummaryBy
      dynamicsCreditApplicationId
      dynamicsApplicantId
      applicantAddress
      lenderDisplayNotify
      dynamicsLenderProfileId
      proposalV2Options
      creditSubmissionDeclineReasonId
      masterCreditSubmissionId
      syndicatedBy {
        id
        email
        dynamicsContactId
        fullName
        title
        phoneNumber
        accountId
      }
      masterLenderName
      approvedRate
      notes
      contingencies
      approvedAmount
      lenderName
      customerAccountRecordDisplayId
      internalNotes
      creditSubStage
      lenderContactInfo {
        id
        email
        dynamicsContactId
        fullName
        title
        phoneNumber
        accountId
      }
      creditDecisionParsedData {
        ...CreditDecisionParsedDataFields
      }
      decisions {
        ...CreditSubmissionDecisionFields
      }
    }
  }
  ${CREDIT_DECISION_PARSED_DATA_FRAGMENT}
  ${CREDIT_SUBMISSION_DECISION_FRAGMENT}
`;
